import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { setGameCase, setGameStatus } from "../../redux/dispatchers";
import { GAME_STAGE } from "../../utils/constant";
import { history } from "../../index";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import male_icon from "../../images/male_head.jpg";
import female_icon from "../../images/female_head.jpg";
import CaseButton from "./case-button";
import { getOptions } from "../../service/api/option";
import { getOne } from "../../service/api/common";

const useStyles = makeStyles(() => ({
  card: {
    display: "inline-block",
    position: "relative",
    marginTop: 30,
    marginLeft: 10,
    marginRight: 10,
    padding: 20,
    width: 270,
    height: 400,
    backgroundColor: "#716162",
    textAlign: "center",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  icon: {
    backgroundColor: "white",
    width: 150,
    height: 145,
    borderRadius: "50%",
    border: "2px solid #f7df28",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    marginBottom: 15,
  },
  buttonContainer: {
    float: "right",
    position: "absolute",
    right: 30,
    bottom: 25,
  },
  detailText: {
    cursor: "context-menu",
    color: "white",
    marginBottom: 10,
  },
  detailLongText: {
    cursor: "context-menu",
    color: "white",
    marginBottom: 10,
  },
  pusher: {
    float: "right",
    width: "0px",
    height: "99px",
  },
  overflowTextBox: {
    color: "white",
    cursor: "context-menu",
    marginBottom: 10,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  expand: {
    marginTop: -10,
    cursor: "pointer",
    color: "#D1D1D1",
    textDecoration: "underline",
    fontWeight: 600,
  },
}));

export default function CaseComponent(props) {
  const classes = useStyles();
  const { kase } = props;
  const [expand, setExpand] = useState(false);
  const [localSetting, setLocalSetting] = useState(kase.setting);

  // get setting on load
  useEffect(() => {
    getOptions("setting", "", kase.setting).then((data) => {
      if (data.length > 0) {
        setLocalSetting(data[0].name);
      }
    });
  }, [kase.setting]);

  const navigatePresentation = () => {
    setGameStatus(GAME_STAGE.PRESENTATION);
    getOne("kases", kase.id).then(({ data }) => {
      setGameCase(data);
      history.push("/presentation");
    });
  };

  const el = document.getElementById(kase.id);
  const isOverflow = !!el && el.clientHeight > 42;

  return (
    <Paper className={classes.card}>
      <img
        className={classes.icon}
        src={kase.gender === "male" ? male_icon : female_icon}
        alt={"Virtual Patient"}
      />
      <Typography className={classes.detailText} variant="subtitle2">
        {kase.name}, {kase.age}
      </Typography>
      <div style={{ height: 183, overflowY: "auto", overflowX: "hidden" }}>
        <div className={classes.pusher} />
        <Typography className={classes.detailText} variant="subtitle2">
          {localSetting}
        </Typography>
        <div
          className={classes.buttonContainer}
          style={{
            clear: "right",
            position: expand ? "static" : "absolute",
            marginRight: expand ? 10 : 0,
          }}
        >
          <CaseButton
            Icon={PlayArrowIcon}
            text="Start"
            onClick={navigatePresentation}
          />
        </div>
        <Typography
          id={kase.id}
          style={{ textAlign: expand ? "left" : "center" }}
          className={
            isOverflow && expand
              ? classes.detailLongText
              : classes.overflowTextBox
          }
          variant="subtitle2"
        >
          {kase.complaints.join(", ")}
        </Typography>
        <Typography
          variant="subtitle2"
          style={{
            display: isOverflow ? "block" : "none",
            textAlign: expand ? "left" : "center",
          }}
          className={classes.expand}
          onClick={() => setExpand(!expand)}
        >
          {expand ? "Show less" : "Show more"}
        </Typography>
      </div>
    </Paper>
  );
}
